import _ from "lodash";

/**
 * Check if any mobile configs have new SIM cards specified.
 * This will mean we need to collect delivery details for them.
 *
 * @param state
 */
export const getMobileSIMsRequired = (state) => {
  let required = false;
  state.mobile.configs.forEach((c) => {
    if (_.get(c, "properties.is_sim_required") == 1) required = true; // eslint-disable-line eqeqeq
  });
  return required;
};

export const getMobileSIMsRequiredCount = (state) => {
  let count = 0;
  state.mobile.configs.forEach((c) => {
    if (
      _.get(c, "properties.is_sim_required") == 1 && // eslint-disable-line eqeqeq
      _.get(c, "properties.sim_type") !== "esim" &&
      _.get(c, "properties.sim_is_buffer") === "0"
    )
      count += 1;
  });
  return count;
};
